// Indian currency formatting (Cr / L / K)
export function formatInr(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) return "₹0";
  const n = Math.round(amount);
  if (n >= 1_00_00_000) {
    const cr = n / 1_00_00_000;
    return `₹${cr.toFixed(cr >= 100 ? 0 : 2)} Cr`;
  }
  if (n >= 1_00_000) {
    const l = n / 1_00_000;
    return `₹${l.toFixed(l >= 100 ? 0 : 2)} L`;
  }
  if (n >= 1_000) {
    return `₹${n.toLocaleString("en-IN")}`;
  }
  return `₹${n}`;
}

// Returns parts so we can animate just the value
export function formatInrParts(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return { value: "0", unit: "" };
  }
  const n = Math.round(amount);
  if (n >= 1_00_00_000) {
    const cr = n / 1_00_00_000;
    return { value: cr.toFixed(cr >= 100 ? 0 : 2), unit: "Cr" };
  }
  if (n >= 1_00_000) {
    const l = n / 1_00_000;
    return { value: l.toFixed(l >= 100 ? 0 : 2), unit: "L" };
  }
  return { value: n.toLocaleString("en-IN"), unit: "" };
}

// For SIP (monthly) — keep full rupee value with commas
export function formatInrFull(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) return "₹0";
  return `₹ ${Math.round(amount).toLocaleString("en-IN")}`;
}
